import React, { useContext } from "react";
import { Card, Row, Col, Typography, Button, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import useTrainings from "PlatForms/OrgLMS/Hooks/LearnerHooks/useTraining";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Title, Text, Paragraph } = Typography;
const Training = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const navigate = useNavigate();
  const learnerId = localStorage.getItem("personalId");
  const token = localStorage.getItem("token");
  const { trainingData, loading } = useTrainings(learnerId, token, false);
  return (
    <Card
      title="Ongoing Trainings"
      loading={loading}
      className="card-professional"
      style={{ maxHeight: "80vh", overflowY: "auto", borderRadius: 12 }}
      extra={
        <Button type="default" onClick={() => navigate("/training")}>
          Back
        </Button>
      }
    >
      {trainingData.length === 0 && !loading ? (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <Empty description="No Ongoing Trainings Available" />
        </div>
      ) : (
        <Row gutter={[24, 24]} style={{ opacity: isBlocked ? 0.6 : 1, pointerEvents: isBlocked ? "none" : "auto" }}>
          {trainingData.map((training) => (
            <Col xs={24} sm={12} md={8} lg={8} key={training.id}>
              <div style={{ position: "relative", marginBottom: 20 }}>
                {training.isRetryTraining && <div className="ribbon-Badge">Repeated</div>}
                <Card
                  variant="borderless"
                  style={{
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    height: "100%",
                  }}
                >
                  <Title level={4} style={{ marginBottom: 24 }}>
                    {training.title}
                  </Title>
                  <Button
                    className="mb-2"
                    type="primary"
                    onClick={() =>
                      navigate("/view-training-detail", {
                        state: {
                          trainingId: training.id,
                          ownMemberId: training.ownMemberId,
                        },
                      })
                    }
                  >
                    View Training Detail
                  </Button>
                  <Paragraph type="secondary">{training.description}</Paragraph>
                  <Text strong>Group:</Text> <Text>{training.groupName}</Text>
                  <br />
                  <Text strong>Mentor ID:</Text> <Text>{training.mentorId}</Text>
                  <br />
                  <Text strong>Start:</Text>{" "}
                  <Text>{moment(training.startDate).format("MMM D, YYYY")}</Text>
                  <br />
                  <Text strong>End:</Text>{" "}
                  <Text>{moment(training.endDate).format("MMM D, YYYY")}</Text>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      )}
    </Card>
  );
};
export default Training;

